<template>
  <Messenger />
  <Loading />
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "./assets/css/main.css";
import Messenger from "./components/utils/Messenger.vue";
import Loading from "./components/utils/Loading";
import store from "./store";

export default {
  name: "App",
  components: {
    Messenger,
    Loading,
  },
  created() {
    // The store restored the token from the local storage, so the user is
    // already logged in at this point. It is checked against the backend,
    // which may have expired it, or forgotten it entirely.
    const token = store.state.token;
    if (!token) return;

    this.$backendDialog
      .checkToken(token)
      .then(() => {
        store.commit("sendMessage", {
          type: "success",
          text: "Welcome back!",
        });
      })
      .catch(() => {
        store.commit("setToken", null);
        store.commit("sendMessage", {
          type: "error",
          text: "Your session has expired, please log in again",
        });
        this.$router.push({ path: "/" });
      });
  },
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  $color1: #d7e2e3; // Stroke
  $color2: #e5e5f7; // Fill
  height: 100vh;
  background-image: linear-gradient(
      $color1 1px,
      $color2 1px,
      $color2 calc(100% - 1px),
      $color1 calc(100% - 1px)
    ),
    linear-gradient(
      90deg,
      $color1 1px,
      $color2 1px,
      $color2 calc(100% - 2px),
      $color1 calc(100% - 1px)
    );
  background-size: 15px 15px;
  overflow: hidden;
}
</style>
